module.exports = __webpack_public_path__ + "img/default.c29a19ca.jpg";